<template>
    <div>
        <p class="p mt-3">
            Обратите внимание: восстановление пароля возможно только при
            верифицированной электронной почте!
        </p>

        <v-form ref="recoveryEmailForm" lazy-validation>
            <v-text-field
                label="Адрес почты"
                v-model="recoveryEmail"
                v-on:input="clearServerError"
                v-on:keyup.enter="validate"
                v-bind:rules="[rules.required, rules.email]"
                validate-on-blur
                v-bind:error-messages="this.$store.state.serverError"
                color="indigo_6"
                outline
                required
            ></v-text-field>

            <!-- form button -->
            <div class="layout column align-center">
                <v-btn
                    class="btn text-capitalize"
                    color="indigo_5"
                    large
                    dark
                    v-on:click="validate"
                    >Запросить</v-btn
                >
            </div>
        </v-form>
    </div>
</template>

<script>
export default {
    name: 'recoveryFormEmail',

    data: () => ({
        recoveryEmail: null,

        rules: {
            required: (value) => !!value || 'Это обязательное поле',
            email: (v) =>
                /.+@.+/.test(v) ||
                'Поле email должно быть действительным электронным адресом',
        },
    }),

    methods: {
        validate() {
            if (this.$refs.recoveryEmailForm.validate()) {
                this.$store.dispatch(
                    'recoveryPasswordEmail',
                    this.recoveryEmail
                );
            }
        },

        clearServerError() {
            this.$store.dispatch('clearServerError');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
